import React from "react";
import { FormattedMessage } from "react-intl";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
export default function getPasswordError(passwordValid, otherPasswordValid, passwordsMatch) {
    if (!passwordValid) {
        return REQUIRED;
    }
    if (otherPasswordValid && !passwordsMatch) {
        return (<FormattedMessage id="forms.passwordChange.passwordsMustMatch" defaultMessage="Passwords must match"/>);
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/getPasswordError.tsx